import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/app-theme.css'
import './styles/unified-tables.css'
import App from './App.vue'
import router from './router'
import { hasPerm, hasAnyPerm } from './auth/session'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$hasPerm = hasPerm
Vue.prototype.$hasAnyPerm = hasAnyPerm

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
